import type { Option } from '@/screens/scan/lib/options'
import type { ScanResult } from '@/screens/scan/types'

export type ResultFilterTab = 'ALL' | 'PASSED' | 'FAILED'

export const RESULT_FILTER_TABS: Option[] = [
  { label: 'All', value: 'ALL' },
  { label: 'Passed', value: 'PASSED' },
  { label: 'Failed', value: 'FAILED' }
]

/** Mirrors ramp-web-app ScannerChecklistItems tab + search filtering. */
export function filterScanResults(
  results: ScanResult[],
  {
    tab,
    query,
    nameFor
  }: {
    tab: ResultFilterTab
    query: string
    nameFor: (row: ScanResult) => string
  }
): ScanResult[] {
  return results
    .filter((item) => {
      if (tab === 'ALL') return true
      if (tab === 'PASSED') return item.scanStatus === 'Pass'
      if (tab === 'FAILED') return item.scanStatus === 'Fail'
      return true
    })
    .filter((item) => {
      if (!query.trim()) return true
      const searchText = nameFor(item).trim().toLowerCase()
      return searchText.includes(query.trim().toLowerCase())
    })
}
